const config = JSON.parse(document.querySelector('body').dataset.config);
export default config;
